import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { generatePath, NavLink } from 'react-router-dom';

const OperationIdCell = ({ row }) => {
  const projectIconCode = useMemo(() => {
    const defaultFlagProjects = ['xc', 'xp', 'xa'];

    const code = row.original.project_code.substring(0, 2).toLowerCase();

    if (defaultFlagProjects.includes(code)) {
      return 'un';
    }

    return code;
  }, [row.original.project_code]);

  const routesConfig = useSelector(state => state.routesConfig);
  const reportLinkPattern =
    routesConfig.root.sub_routes.report_detail_no_section.path;

  return (
    <NavLink
      className="project-number-link"
      data-test-id="operation-id-link"
      to={
        generatePath(reportLinkPattern, {
          cpb: row.original.project_code,
          year: row.original.period,
        }) + '/'
      }
    >
      <span className={`fi fi-${projectIconCode} flag-icon-wrapper`}></span>
      {row.original.project_code}
    </NavLink>
  );
};

export default OperationIdCell;
